exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".field-module-root{min-width:100%}", "",{"version":3,"sources":["/opt/buildhome/repo/src/overrides/venia-ui/components/Field/field.module.scss"],"names":[],"mappings":"AAAA,mBACI,cAAA","file":"field.module.scss","sourcesContent":[".root {\n    min-width: 100%;\n}"]}]);

// Exports
exports.locals = {
	"root": "field-module-root"
};